export default __webpack_public_path__ + "static/media/select-zoom.f8d89ea9.png";